import React from 'react';
import { Clock, Search, ShieldCheck, ThumbsUp } from 'lucide-react';
export function WhyChooseUs() {
  const values = [{
    icon: <Clock className="h-8 w-8" data-id="element-210" />,
    title: 'Available 24/7',
    description: 'Book on your schedule, any time of day.'
  }, {
    icon: <Search className="h-8 w-8" data-id="element-211" />,
    title: 'Detail Obsessed',
    description: 'We clean the spots others skip.'
  }, {
    icon: <ShieldCheck className="h-8 w-8" data-id="element-212" />,
    title: 'Trusted & Insured',
    description: 'Vetted, professional, and fully covered.'
  }, {
    icon: <ThumbsUp className="h-8 w-8" data-id="element-213" />,
    title: 'Satisfaction Guaranteed',
    description: "Not happy? We'll make it right."
  }];
  return <section className="py-20 md:py-32 bg-brand-navy text-brand-white" data-id="element-214">
      <div className="container mx-auto px-4 md:px-6" data-id="element-215">
        <div className="text-center mb-16 md:mb-24" data-id="element-216">
          <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl" data-id="element-217">
            Why Deep Clean Cleaners
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8" data-id="element-218">
          {values.map((value, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-219">
              <div className="bg-brand-white/5 p-5 rounded-2xl mb-6 text-brand-aqua group-hover:bg-brand-aqua group-hover:text-brand-navy transition-colors duration-300" data-id="element-220">
                {value.icon}
              </div>
              <h3 className="font-display font-bold text-xl text-brand-aqua mb-3" data-id="element-221">
                {value.title}
              </h3>
              <p className="text-brand-sky text-base md:text-lg leading-relaxed max-w-xs" data-id="element-222">
                {value.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}